"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import { useTranslations } from "next-intl";
import { useReducedMotion } from "@/hooks/useFramerMotion";
import { ModalShell } from "@/components/ui/AnimatedModal";
import { Meteors } from "@/components/ui/Meteors";
import { useContactModalOpen, closeContactModal } from "@/contexts/ContactModalContext";
import ContactForm from "@/components/Contact/ContactForm";
import Heading from "@/components/ui/Heading";
import RichText from "@/components/RichText";
const ContactModal = () => {
  const $ = _c(23);
  const open = useContactModalOpen();
  const reduce = useReducedMotion();
  const tCommon = useTranslations("common");
  const tContact = useTranslations("contact");
  const closeTimer = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      if (closeTimer.current) {
        clearTimeout(closeTimer.current);
        closeTimer.current = null;
      }
      closeContactModal();
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleClose = t0;
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => () => {
      if (closeTimer.current) {
        clearTimeout(closeTimer.current);
      }
    };
    t2 = [];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      closeTimer.current = setTimeout(_temp, 4000);
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleSuccess = t3;
  let t4;
  if ($[4] !== tCommon) {
    t4 = tCommon("sendMessage");
    $[4] = tCommon;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== reduce) {
    t5 = !reduce && <Meteors number={30} />;
    $[6] = reduce;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== tCommon) {
    t6 = tCommon("sendMessage");
    $[8] = tCommon;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <Heading fx={true} className="text-mint" level={4}>{t6}</Heading>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== tContact) {
    t8 = <div className="font-secondary leading-relaxed text-primary/80 ~text-sm/base ~mt-3/4 ~mb-6/8"><RichText>{tags => tContact.rich("text", tags)}</RichText></div>;
    $[12] = tContact;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ContactForm variant="modal" onSuccess={handleSuccess} />;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t7 || $[16] !== t8) {
    t10 = <div className="relative z-[1] ~pt-1/2">{t7}{t8}{t9}</div>;
    $[15] = t7;
    $[16] = t8;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== open || $[19] !== t10 || $[20] !== t4 || $[21] !== t5) {
    t11 = <ModalShell open={open} onClose={handleClose} ariaLabel={t4} backdropClassName="z-[60] overflow-y-auto bg-dark/70" wrapperClassName="flex min-h-full items-center justify-center p-4 [perspective:800px] max-md:p-0" className="z-[60] w-full max-w-lg overflow-hidden rounded-2xl border border-white/15 bg-dark ~p-6/10 max-md:min-h-full max-md:rounded-none max-md:border-0" closeBtnClassname="right-3 top-6 p-2 text-primary transition-colors duration-300 hover:text-accent" closeIconClassName="size-6" initialFocus="input:not([aria-hidden='true']), textarea">{t5}{t10}</ModalShell>;
    $[18] = open;
    $[19] = t10;
    $[20] = t4;
    $[21] = t5;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
};
export default ContactModal;
function _temp() {
  return closeContactModal();
}